import React from 'react'

const PhoneNumber = () => {
  return (
    <div className="phone-container">
      <h2>
        Call Now for a <strong className="red">FREE</strong> Estimate!
      </h2>
      <h2 className="fs-42">469-338-8263</h2>
    </div>
  )
}
export default PhoneNumber
